module.exports = __webpack_public_path__ + "static/media/checkbox-blue-active.51b71e5e.svg";